// 'platform' only exists in TENANCY_MODE=pool (#1626) — cross-tenant, no
// tenantId of its own. Fisia/Centauro (silo) never issue it.
export const ROLES = { ADMIN: 'admin', OPERATOR: 'operator', VIEWER: 'viewer', REPORTS: 'report-viewer', MONITOR: 'monitor', PLATFORM: 'platform' };
